import { DateCell } from "@/components/date/cell";
import { EmployeeCell } from "components/cell/employee/cell";
import CreateListItemButton from "@/components/list/create-button";
import { StatusCell } from "@/components/status/cell";
import { getdirectusUserFields } from "components/user/config";
import { List } from "components/index";
import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";

const PullRequests = () => {
  const user = useSelector(selectUser);
  const fields = [
    "id",
    "url",
    "status",
    getdirectusUserFields("user_created"),
    "date_created",
  ];

  const columns = [
    {
      id: "url",
      header: "URL",
      accessorKey: "url",
    },

    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      id: "created by",
      header: "Created By",
      accessorKey: "user_created",
      cell: EmployeeCell,
    },
    {
      id: "created at",
      header: "Created At",
      accessorKey: "date_created",
      cell: DateCell,
    },
  ];

  return (
    <div className="flex-1">
      <CreateListItemButton collection="pull_requests">
        Create Pull Request
      </CreateListItemButton>

      <List
        title="Pull Requests"
        showSearch={false}
        storageKey={`pull-requests-${user.id}`}
        endPoint="pull_requests"
        columns={columns}
        meta={{ fields }}
        href={(item) => `/apps/pull-requests/${item.id}/edit`}
      />
    </div>
  );
};

export default PullRequests;
